import React, { Component } from 'react';
//import { Route } from 'react-router';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useHistory,
  useLocation
} from "react-router-dom";

import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { GhoreKeshi } from './components/GhoreKeshi';
import { PrizePage } from './components/PrizePage';
import { Register } from './components/Register';
import { SendSMSTable } from './tables/sendSMS/SendSMSTable';
import { RecieveSMSTable } from './tables/recieveSMS/RecieveSMSTable';
import { PointTable } from './tables/point/PointTable';
//import { Login } from './components/Login';
import { MyInput } from './elements/MyInput';
import { Logout } from './components/Logout';

import { MemberTable } from './tables/member/MemberTable';

import { AggregateMobileTable } from './tables/aggregateMobile/AggregateMobileTable'
import { ProductTable } from './tables/product/ProductTable'
import { Table } from 'reactstrap';

import { PageTemplate } from "./components/PageTemplate"


import { GhoreOperation } from "./components/GhoreOperation"
import { WinnerTable } from './tables/winner/WinnerTable';

import { TaskTable } from './tables/task/TaskTable';
import { WinnerBox } from './elements/WinnerBox';

import { DivTrain } from './elements/DivTrain'

import {AnimatedMobile }from './elements/AnimatedMobile'

import {Block} from './components/Block'
export const fakeAuth =
{
  isAuthenticated: false,
  authenticate(cb) {
    fakeAuth.isAuthenticated = true;
    setTimeout(cb, 100); // fake async
  },
  signout(cb) {
    fakeAuth.isAuthenticated = false;
    setTimeout(cb, 100);
  }
};

function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        fakeAuth.isAuthenticated ? (
          children
        ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
      }
    />
  );
}




export default class App extends Component {
  static displayName = App.name;


  constructor(props) {
    super(props);
    this.state = {};
    this.state.IsLogin = false;
    this.state.preIsLogin = false;
    this.onAuthenticate = this.onAuthenticate.bind(this);
    this.onHideMasterPage = this.onHideMasterPage.bind(this);

    this.state.hidemaster = false;
  }

  onAuthenticate() {

  }

  onHideMasterPage(data) {

    // alert("hide master-page");
    console.log("data");
    console.log(data);
    this.state.ceremonyId = data;
    this.state.type = "ghore";
    this.setState({});
  }




  render() {


    var token = localStorage.getItem('token');

    this.state.isLogin = false;
    if (token !== null && token !== "" && token != 'null') {
      this.state.isLogin = true;
    }

  //  console.log("token" + token);
   // console.log(this.state.isLogin);


    if (this.state.isLogin && this.state.preIsLogin == false) {
      this.state.preIsLogin = true;
      fakeAuth.authenticate(() => {
        this.setState(() => ({
          isLogin: true
        }))
      })
    }
    else {
      this.state.preIsLogin = false;
    }


    //return (<PageTemplate username="Majid Ghasimi"> </PageTemplate>);

    if (this.state.type == "ghore") {

      return (
        <GhoreOperation ceremonyId={this.state.ceremonyId} />

      );
    }


    var loginName = "خوش آمدید";

    const { from } = { from: { pathname: '/' } };

    return (
      <div style={{ width: "100%" }}>
        <Route exact path='/' component={Home} />

        <Route path='/login' component={Login} onAuthenticate={this.onAuthenticate} />

        <PrivateRoute path="/pointTable">

          <PageTemplate username={loginName} pageLabel="امتیازها" link="/pointTable">
            <PointTable />
          </PageTemplate>
        </PrivateRoute>


        <PrivateRoute path="/ghorekeshi">

          <PageTemplate hidemaster={this.state.hidemaster} username={loginName} pageLabel=" تعریف و مدیریت قرعه کشی ها" link="/ghorekeshi">
            <GhoreKeshi onHideMasterPage={this.onHideMasterPage} />
          </PageTemplate>

        </PrivateRoute>




        <PrivateRoute path="/prizePage">


          <PageTemplate username={loginName} pageLabel="جوایز" link="/prizePage">
            <PrizePage />
          </PageTemplate>

        </PrivateRoute>


        
        <PrivateRoute path="/block">


          <PageTemplate username={loginName} pageLabel="حذفیات" link="/block">
            <Block />
          </PageTemplate>

        </PrivateRoute>



        <PrivateRoute path="/winner">


          <PageTemplate username={loginName} pageLabel=" گزارش برندگان" link="/winner">
            <WinnerTable />
          </PageTemplate>

        </PrivateRoute>

        <PrivateRoute path="/sendSMSTable">
          <PageTemplate username={loginName} pageLabel="پیامکهای ارسالی" link="/sendSMSTable">
            <SendSMSTable />
          </PageTemplate>
        </PrivateRoute>

        <PrivateRoute path="/memberTable">

          <PageTemplate username={loginName} pageLabel="پروفایل شرکت کنندگان" link="/memberTable">   
            <MemberTable />
          </PageTemplate>


        </PrivateRoute>


        <PrivateRoute path="/recieveSMSTable">
          <PageTemplate username={loginName} pageLabel="ریز گزارش شرکت کنندگان " link="/recieveSMSTable">
            <RecieveSMSTable />
          </PageTemplate>

        </PrivateRoute>

        <PrivateRoute path="/taskTable">
          <PageTemplate username={loginName} pageLabel="گزارشات" link="/taskTable">
            <TaskTable />
          </PageTemplate>

        </PrivateRoute>

        



        

        <PrivateRoute path="/productTable">

          <PageTemplate username={loginName} pageLabel="گزارش محصولات" link="/productTable">
            <ProductTable />
          </PageTemplate>

        </PrivateRoute>




        <Route path="/logout" component={Logout} />

        <Route path="/r/:id" component={Register} />
        <Route path="/rc/:id/:productcat" component={Register} />
      </div>
    );
  }
}
class Login extends Component {


  constructor(props) {


    super(props);
    this.state = { currentCount: 0, isLoading: false, redirectToReferrer: false };
    this.state.data = {};
    //  this.incrementCounter = this.incrementCounter.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);

    this.headers =
    {
      'Content-Type': 'application/json'
    };
  }

  handleSubmit(e) {
    e.preventDefault();

    var data = this.state.data;
    //    console.log(data);

    //      console.log(JSON.stringify(data));
    this.setState({ isLoading: true });
    fetch('api/v1/Login',
      {
        method: 'POST',
        body: JSON.stringify(data),
        headers: this.headers
      }).then(res => {
        this.status = res.status;

        res.json().then((result) => {
          this.setState({ isLoading: false });
          this.setState({});


          if (res.status === 200) {
            localStorage.setItem('token', result.token);
            fakeAuth.authenticate(() => {
              this.setState(() => ({
                redirectToReferrer: true
              }))
            })
          }
          else {
            alert(result.Value);
            console.log(result);
          }

          // if (typeof this.props.onAuthenticate === "function")
          //  this.props.onAuthenticate(res.token, res.name);
        },
          (error) => {
            this.setState({ isLoading: false });
          }
        );
      }
      );


  }
  onFormChange() {

  }

  handleTextChange(e, key) {
    this.state.data[key] = e;
    this.setState({});
  }





  render() {
    if (this.state.isLoading) {
      return <div>...</div>;
    }

    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer === true) {
      return <Redirect to={from} />;
    }






    return (
      <div className="container">
        <div className=" col-md-12 row">

          <hr />
          <br></br>


          <div className="col-md-12 row" style={{ marginTop: "-50px" }}>
            <div className="col-md-4">

            </div>

            <div className="col-md-4 col-sm-12" >

              <img src={require('./images/logo.png')} style={{ width: '100%' }} />
              <div className="text-justify text-center" style={{ width: '100%', fontSize: '30px' }} > سامانه قرعه کشی آلین کیش</div>
              <br />
              <form className="" onSubmit={this.handleSubmit} ref="myRef">
                <MyInput onChange={this.handleTextChange} label="نام کاربری" name="username" ></MyInput>
                <br />
                <MyInput onChange={this.handleTextChange} IsPassword={true} label="رمز عبور" name="password" ></MyInput>
                <br />
                <button className="btn btn-primary btn-block" onClick={this.handleSubmit}>ورود </button>
                <br />
              </form>
            </div>

            <div className="col-md-4">

            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js